import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { LANGS } from "./content/shared";
import { useSystemTheme } from "./theme";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Product from "./pages/Product";
import HowItWorks from "./pages/HowItWorks";
import { UseCases, UseCase } from "./pages/UseCases";
import { Pricing, Safety, Help, About, Download, NotFound } from "./pages/Pages";
import Contact from "./pages/Contact";
import { Legal, Deletion } from "./pages/Legal";

// Device time zone -> language of that country (no network call, no personal data leaves the device).
const TZ = {
  sq: ["Europe/Tirane"],
  it: ["Europe/Rome", "Europe/San_Marino", "Europe/Vatican"],
  de: ["Europe/Berlin", "Europe/Vienna", "Europe/Zurich", "Europe/Vaduz", "Europe/Busingen"],
  es: ["Europe/Madrid", "Atlantic/Canary", "Africa/Ceuta", "America/Mexico_City", "America/Bogota", "America/Lima", "America/Santiago", "America/Caracas", "America/Argentina/Buenos_Aires", "America/Montevideo", "America/Guayaquil"],
  fr: ["Europe/Paris", "Europe/Monaco"],
  pt: ["Europe/Lisbon", "Atlantic/Madeira", "Atlantic/Azores", "America/Sao_Paulo", "America/Fortaleza", "America/Recife", "America/Bahia", "America/Manaus", "America/Belem"],
};

// Order: language picked earlier on this device -> country from the device location (time zone) -> browser language -> English.
export const detect = () => {
  if (typeof window === "undefined") return "en";
  try {
    const saved = localStorage.getItem("cp-lang");
    if (LANGS.includes(saved)) return saved;
  } catch (e) { /* storage blocked */ }
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const byTz = Object.keys(TZ).find((l) => TZ[l].includes(tz));
  if (byTz) return byTz;
  const nav = (navigator.languages || [navigator.language || "en"]).map((x) => x.slice(0, 2).toLowerCase()).find((x) => LANGS.includes(x));
  return nav || "en";
};

const Legacy = ({ to }) => {
  const { lang } = useParams();
  return <Navigate to={`/${lang}/${to}/`} replace />;
};

export const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to={`/${detect()}/`} replace />} />
    <Route path="/:lang" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="product" element={<Product />} />
      <Route path="features" element={<Legacy to="product" />} />
      <Route path="how-it-works" element={<HowItWorks />} />
      <Route path="use-cases" element={<UseCases />} />
      <Route path="use-cases/:slug" element={<UseCase />} />
      <Route path="pricing" element={<Pricing />} />
      <Route path="privacy-safety" element={<Safety />} />
      <Route path="help" element={<Help />} />
      <Route path="faq" element={<Legacy to="help" />} />
      <Route path="about" element={<About />} />
      <Route path="support" element={<Contact />} />
      <Route path="contact" element={<Legacy to="support" />} />
      <Route path="download" element={<Download />} />
      <Route path="privacy" element={<Legal doc="privacy" />} />
      <Route path="terms" element={<Legal doc="terms" />} />
      <Route path="child-safety" element={<Legal doc="child" />} />
      <Route path="impressum" element={<Legal doc="impressum" />} />
      <Route path="account-deletion" element={<Deletion />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default function App({ children }) {
  useSystemTheme();
  return children || <AppRoutes />;
}
